import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import AddToPhotosOutlinedIcon from "@mui/icons-material/AddToPhotosOutlined";
import ContentCopy from "@mui/icons-material/ContentCopy";
import ContentCut from "@mui/icons-material/ContentCut";
import ContentPaste from "@mui/icons-material/ContentPaste";
import DeleteIcon from "@mui/icons-material/Delete";
import PostAddIcon from "@mui/icons-material/PostAdd";
import SortIcon from "@mui/icons-material/Sort";
import { Button, Divider, GridLegacy, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import axios, { AxiosRequestConfig } from "axios";
import dayjs, { Dayjs } from "dayjs";
import React, { type JSX, useEffect, useRef } from "react";
import {
  appConfig,
  imagesAtom,
  isAdminAtom,
  refreshSectionDataAtom,
  sectionListAtom,
  smetaStore,
  userRightsAtom,
} from "../../../atoms";
import { PermissionFlags, SmetaSplitterElement } from "../../ComponentInterface";
import smetaAxios from "../../SmetaAxios";
import { setClientInfo } from "../../Singin/SingIn";
import {
  buildFileSelector,
  CheckModalBackGrounds,
  getBase64ByFileReader,
  renderMessageBox,
  tokenProcessingTest,
} from "../../TokenProcessing/TokenProcessing";
import { AxiosRequest, checkGenLicGuid, getOptionsForUser, ImgURL, XMLrequest } from "../../Url";
import { parseCommand, stmjsonClick } from "../NotWorkArea(Side&Head)/Header/Header";
import { getParamColumnsOptions } from "../rcsgrid/GridTools/parseColumnTools";
import { defaultDocsSettings } from "../Sections/ElementsSections/SectionDocuments/CheckBoxedForDocandSettings";
import { ShowDoc, ViewClass } from "./Consts";
import { getAllDataBD } from "./IndexedBd";
import { NestedMenuItem } from "./NestedMenuOrigin/NestedMenuItem";
import { Button as DlgButton, DlgRes, DlgType, FontStyle, Prefixes } from "./ProjectX";
import { smetaModals } from "./modalManager";
import DialogSetObjText from "../Module/Dialogs/DialogSetObjText";
import { SectionsList } from "../NotWorkArea(Side&Head)/SideBar/SideBarInterface";
import { mfDelete, mfEdit, mfView } from "../rcsgrid/rcsgrid";
import checkboxBulletIcon from "../../../static/images/icons/checkbox-bullet.png";
import checkboxRightArrowBlueIcon from "../../../static/images/icons/checkbox-right-arrow-blue.png";
import checkboxRightArrowRedIcon from "../../../static/images/icons/checkbox-right-arrow-red.png";

let resultArray: any;

export const getEsiaUrls = () => ({
  org: `${window.location.origin}/esia?what=esia_org`,
  logout: `${window.location.origin}/esia?what=esia_logout`,
  auth: `${window.location.origin}/esia`,
});

export const escapeRegExp = (string: string) => {
  return string.replaceAll(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
};

export const defaultFieldInfo = {
  options: getParamColumnsOptions(0),
  Values: [],
};

export function isEmptyObject(obj: object | null | undefined) {
  for (const i in obj) {
    if (obj.hasOwnProperty(i)) {
      return false;
    }
  }
  return true;
}

export const wait = async (time?: number) => {
  return new Promise<void>((res) => {
    setTimeout(() => {
      res();
    }, time || 0);
  });
};

export interface HandleFiles {
  [key: string]: {
    name: string;
    rcdata: string;
    size: number;
    fileType: string;
  };
}
export const handleFiles = async (fileList: FileList) => {
  if (!fileList || !fileList[0]) return { finalData: {}, filesNames: [] };
  const files = Array.from(fileList);
  // const fixedName = name === "image.png" ? `Рисунок${getStrDateOfDateObj()}${getStrTimeOfDateObj()}.png` : name;
  const getFileName = (name) =>
    name === "image.png" ? `Рисунок${getStrDateOfDateObj()}${dayjs().format("HH.mm")}.png` : name;
  const filesNames = files.map((file) => getFileName(file.name));
  const filesData = await Promise.all(files.map((file) => getBase64ByFileReader(file)));
  const finalData: HandleFiles = filesData.reduce((acc, fileData, index) => {
    const { name, size } = files[index];
    const { rcdata, fileType } = fileData;
    const fixedName = getFileName(name);
    return {
      ...acc,
      [fixedName]: {
        size,
        rcdata,
        fileType,
        name: fixedName,
      },
    };
  }, {});
  return {
    finalData,
    filesNames,
  };
};

export const selectNewLicenseToInstall = async (): Promise<
  | {
      reqData: { FileName: string };
      files: { [key: string]: { rcdata: string } };
    }
  | undefined
> => {
  const licenseFile = await buildFileSelector({ filter: ".lic" });
  return licenseFile;
};

export const selectOrg = ({
  drx = "",
  user = "",
}): Promise<{ code: string; text: string; id: string; config: string } | null> => {
  return new Promise(async (resolve) => {
    if (!drx) return resolve(null);
    const config: AxiosRequestConfig = {
      params: {
        configName: encodeURIComponent(drx),
        userName: encodeURIComponent(user),
      },
    };
    const resp = await smetaAxios.get<{
      Items?: { items?: { ID: string; Name: string; Code: string; Config: string }[] };
    }>("GetOrgClsList", config);
    const items = resp?.Items?.items ?? [];
    if (items.length === 0 || (items.length === 1 && isEmptyObject(items[0]))) return resolve({ config: drx });
    const list = items.map((val) => {
      return {
        text: val.Name,
        id: val.ID,
        code: val.Code,
        config: val.Config,
      };
    });
    const onClose = () => {
      resolve(null);
    };
    smetaModals.open(
      <DialogSetObjText
        list={list}
        onEdit={(e: any) => {
          resolve({ code: e.code, text: e.value, id: e.tag, config: e.config || drx });
        }}
      />,
      {
        style: getStyleWindow(),
        blockMaximize: true,
        Title: "Выбор организации",
        onClose,
      },
    );
  });
};

export const downloadErrorFile = async () => {
  const data = await getAllDataBD("smeta", "errors");
  const link = document.createElement("a");
  const currentLicGuid = sessionStorage.getItem("LicG");
  link.download = `${currentLicGuid || "errors"}.json`;
  const blob = new Blob([JSON.stringify(data)], { type: "text/plain" });
  const url = window.URL.createObjectURL(blob);
  link.href = url;
  link.click();
};

export function isDeveloper() {
  const lastLogin = localStorage.getItem("LastLogin");
  if (!lastLogin) return false;
  const developers = [
    "Романов Станислав Павлович",
    "Смирнов Сергей Валерьевич",
    "Беляев Даниил Александрович",
    "Ковалев Андрей Владимирович",
    "Голенкевич Владимир Александрович",
    "Фаустов Ростислав Андреевич",
  ];
  return developers.includes(lastLogin.split(",")[1]);
}

export const openDocumentInModal = (doccfgid: string, docid: string) => {
  tokenProcessingTest({
    Module: "documents",
    Token: "ExposeDocument",
    Break: "1",
    Params: {
      DocCfgID: doccfgid,
      DocID: docid,
      Options: String(ShowDoc.Modal | ShowDoc.Single),
      RequestID: "0",
    },
  });
};

interface SessionInfoResponse {
  Result?: string | number;
  Active?: string | number;
}

// Сколько ждём ответ сервера при запуске приложения (мс).
// Лимит только для запросов запуска: остальные запросы могут быть долгими, их обрывать нельзя.
export const initRequestTimeout = 20000;

export async function isSessionActive() {
  const { from } = getOptionsForUser() || {};
  const needToCheckMultiSession = smetaStore.get(appConfig).smeta.multiSession && from !== "lk";
  const savedLicGUID = needToCheckMultiSession ? sessionStorage.getItem("LicG") : localStorage.getItem("login");
  const licGUID = savedLicGUID || checkGenLicGuid("", true);
  const reqConfig: AxiosRequestConfig = {
    prefix: Prefixes.default,
    loadMask: true,
    timeout: initRequestTimeout,
    params: {
      info: "3",
      LicGUID: licGUID,
    },
  };
  checkDocsSettings();
  let json = await smetaAxios.get<SessionInfoResponse | null | "">("info", reqConfig);
  let result = json ? (json.Result ?? json.Active) : undefined;
  if (result === undefined && savedLicGUID) {
    // После простоя info может быть пустым до восстановления подключения к прежней сессии.
    await setClientInfo(licGUID, initRequestTimeout);
    json = await smetaAxios.get<SessionInfoResponse | null | "">("info", reqConfig);
    result = json ? (json.Result ?? json.Active) : undefined;
  }
  return { active: result === "1" || result === 1, licGUID, multiSession: needToCheckMultiSession };
}

export function checkDocsSettings() {
  const docState = localStorage.getItem("docState");
  if (docState !== null && docState !== "" && JSON.parse(docState)["save"]) return JSON.parse(docState);
  localStorage.setItem("docState", JSON.stringify(defaultDocsSettings));
  return defaultDocsSettings;
}

export const MenuItems = (json: any, click: any, state: any, GetDisable: any, props: any) => {
  return (
    <GridLegacy container direction="row" justifyContent="flex-start" alignItems="center">
      <GridLegacy
        item
        style={{
          backgroundColor: "#e6e6e6",
          position: "absolute",
          height: "100%",
          width: "46px",
        }}
      />
      <GridLegacy item>
        {json.map((item: any, index: number) => {
          if (item.Caption === "-") {
            return <Divider key={`ButtonsMenu-Divider_${index}`} orientation="horizontal" flexItem />;
          } else if (item.items) {
            let Disabled = false,
              itemsArr = [];
            itemsArr = MenuItems(item.items, click, state, GetDisable, props);
            if (state) {
              Disabled = GetDisable(item.ID, state, Disabled);
            }
            return (
              <NestedMenuItem
                id={item.ID}
                onClick={click}
                disabled={Disabled}
                formid={item.ID}
                // style={{ height: "25px" }}
                key={"ButtonsMenu" + index}
                doccfgid={props && props.doccfgid ? props.doccfgid : undefined}
                style={{
                  paddingLeft: "26px",
                  height: "25px",
                  marginLeft: item.Image && item.ID ? 2 : 18,
                }}
                leftIcon={
                  item.Image && item.ID
                    ? ImgURL(item.Image, {
                        height: "16px",
                        width: "16px",
                        marginLeft: -13,
                        marginTop: 3,
                        marginRight: 13,
                      })
                    : ""
                  // {item.Image && !item.ID && !item.Status ? item.Image : null}
                }
                label={item.Name ? item.Name : item.Caption}
                parentMenuOpen={true}
              >
                {itemsArr}
              </NestedMenuItem>
            );
          } else {
            let Disabled = false;
            if (state) {
              Disabled = GetDisable(item.ID, state, Disabled);
            }
            return (
              <MenuItem
                id={item.ID}
                onClick={click}
                disabled={Disabled}
                formid={item.ID}
                style={{ height: "25px" }}
                key={"ButtonsMenu" + index}
                doccfgid={props && props.doccfgid ? props.doccfgid : undefined}
              >
                <ListItemIcon>
                  {item.Image && item.ID ? ImgURL(item.Image, { width: "20px" }) : null}
                  {item.Image && !item.ID && !item.Status ? item.Image : null}
                </ListItemIcon>
                <ListItemText>{item.Name ? item.Name : item.Caption}</ListItemText>
              </MenuItem>
            );
          }
        })}
      </GridLegacy>
    </GridLegacy>
  );
};

export function setActiveSection(id: string) {
  if (id !== "") {
    smetaAxios.get("SetActiveSection", { params: { SectionID: id }, loadMask: false });
  }
}

export function getIcons(id?: string | number) {
  const json = smetaStore.get(imagesAtom);
  return json.Images?.[id] ? json.Images[id].Image : null;
}

export function outPutShow(text: string | undefined) {
  const outPutInput = document.getElementById("OutPutInput") as HTMLTextAreaElement | null;
  if (outPutInput) {
    const outPutTextSplitter = document.getElementById("OutPutTextSplitter") as SmetaSplitterElement;
    if (text === undefined) {
      outPutInput.value = "";
    } else {
      outPutTextSplitter.expand(true);
      outPutInput.value += text + "\n";
    }
  }
}

export async function getIconsAsync(id: number) {
  let json = smetaStore.get(imagesAtom);
  if (json.length === 0) {
    const config: AxiosRequestConfig = { prefix: Prefixes.resours, params: { handle: "161601", index: "-1" } };
    json = await smetaAxios.get("getImage", config);
    smetaStore.set(imagesAtom, json);
  } else {
    json = smetaStore.get(imagesAtom);
  }
  return json?.Images?.[id]?.Image || null;
}

export function clearNoneBreadCrumbs() {
  const breadcrumbs = document.getElementById("BreadcrumbsSelected").firstChild;
  for (const val of Object.values(breadcrumbs.children)) {
    if (val.id === "noneBreadcrumbs") {
      val.remove();
    }
  }
}

export function extend() {
  // Variables
  const extended = {};
  let deep = false;
  let i = 0;

  // Проверьте, не произошло ли глубокое слияние
  if (typeof arguments[0] === "boolean") {
    deep = arguments[0];
    i++;
  }

  // Объедините объект с расширенным объектом
  const merge = function (obj) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") {
          // Если мы выполняем глубокое слияние и свойство является объектом
          extended[prop] = extend(true, extended[prop], obj[prop]);
        } else {
          // В противном случае выполните обычное слияние
          extended[prop] = obj[prop];
        }
      }
    }
  };

  // Пройдитесь по каждому объекту и выполните слияние
  for (; i < arguments.length; i++) {
    merge(arguments[i]);
  }

  return extended;
}

export const createPdfIframe = (rcdata: string) => {
  return (
    <iframe
      src={"data:application/pdf;base64," + rcdata}
      height="100%"
      className="iframeStimateCustom"
      style={{ width: "100%", height: "100%" }}
    />
  );
};

export function clickInFrame(viewIdent: any, frameElem: any, data: unknown) {
  if (data.changeText) ChangeCellText(viewIdent, frameElem);
  if (data.linkRef) LinkrefClick(viewIdent, frameElem, data);
}

function LinkrefClick(ViewIdent: any, frameElem: any, data: any) {
  try {
    // /cellobj~CallCellHandler?LicGUID=4F75AB084C00BEEC47D6CBB52258AB11&Command=EditRef&ViewIdent={1B3C2820-705D-48DD-BA7B-19FFA95073C3}&Path=Root\1\2\4&SectionID=109&WSM=1 ...
    let frame;
    if (frameElem) {
      frame = frameElem;
    } else {
      const frams = document.querySelectorAll(".Params.ActivParams");
      for (let n = 0; n <= frams.length - 1; n++) {
        frame = frameElem === undefined ? frams[n].querySelector("iframe.ActivReport") : frameElem;
      }
    }
    const AllLinksInFrame = frame.contentDocument.getElementsByClassName("linkref");
    for (const value of Object.values(AllLinksInFrame)) {
      if (value.onclick === null) {
        value.command = "EditRef";
        value.viewident = ViewIdent;
        value.path = value.getAttribute("data-path");
        value.sectionid = data.ID;
        value.onclick = function (event) {
          CallCellHandler(event);
        };
      }
    }
    const allLinksInFrame = frame.contentDocument.getElementsByTagName("a");
    for (const value of Object.values(allLinksInFrame)) {
      if (value.href && value.onclick === null) {
        const command = parseCommand(value.href);
        value.onclick = function () {
          stmjsonClick(command);
        };
      }
    }

    frame.changed = "1";
  } catch {}
}

function ChangeCellText(ViewIdent: any, frameElem: any) {
  try {
    let frame;
    if (frameElem) {
      frame = frameElem;
    } else {
      const frams = document.querySelectorAll(".Params.ActivParams");
      for (let n = 0; n <= frams.length - 1; n++) {
        frame = frameElem === undefined ? frams[n].querySelector("iframe.ActivReport") : frameElem;
      }
    }
    const AllBlocksThatCanChangeValue = frame.contentDocument.querySelectorAll("[data-path]");
    for (const value of Object.values(AllBlocksThatCanChangeValue)) {
      if (value.ondblclick === null) {
        value.ondblclick = function (event: any) {
          const textBlock = event.currentTarget.children[0].children[0];
          const input = document.createElement("input");
          input.type = "text";
          input.path = value.getAttribute("data-path");
          input.viewident = ViewIdent;
          input.command = "setText";
          input.style.outline = "none";
          input.style.position = "relative";
          input.style.width = value.offsetWidth - 6 + "px";
          // input.style.width = "inherit";
          input.style.height = value.offsetHeight - 4 + "px";
          input.style.border = "none";
          input.style.fontSize = "inherit";
          input.value = textBlock.textContent;
          input.onblur = function (event) {
            value.children[0].style.display = "";
            value.style.padding = "";
            changeEvent(event, textBlock);
          };
          input.onkeydown = function (event) {
            if (event.key === "Enter") {
              value.children[0].style.display = "";
              value.style.padding = "";
              changeEvent(event, textBlock);
            }
          };
          value.children[0].style.display = "none";
          value.style.padding = "0px";
          value.appendChild(input);
          input.focus();
        };
      }
    }
  } catch {}
}

function changeEvent(event: any, textBlock: any) {
  if (textBlock.textContent !== event.currentTarget.value) {
    CallCellHandler(event);
    textBlock.textContent = event.currentTarget.value;
  }
  event.target.remove();
}

function CallCellHandler(event: any) {
  const params = new Map(),
    currentTarget = event.currentTarget;
  const viewIdent = currentTarget.viewident.split(".");
  params.set("prefix", "cellobj");
  params.set("comand", "CallCellHandler");
  if (currentTarget.Command === "setText") {
    params.set("Text", currentTarget.value);
    params.set("Changed", "1");
  }
  if (currentTarget.sectiodid) {
    params.set("SectionID", currentTarget.sectiodid);
  }
  params.set("Command", currentTarget.command);
  params.set("ViewIdent", viewIdent.length > 1 ? viewIdent[1] : viewIdent[0]);
  params.set("Path", currentTarget.path);
  params.set("WSM", "1");
  AxiosRequest(true, params).then((res) => {
    tokenProcessingTest(res);
  });
}

export const getSectionByID = (idToFind: string, sectionsArrData?: SectionsList[]): SectionsList | undefined => {
  const localSections = sectionsArrData || smetaStore.get(sectionListAtom);
  if (!localSections || localSections.length === 0) return;

  for (const section of localSections) {
    if (section.ID === idToFind) {
      return section;
    }
    if (section.Sections) {
      const found = getSectionByID(idToFind, section.Sections);
      if (found) {
        return found;
      }
    }
  }

  return;
};

export const getDocInfo = async (docId: string) => {
  const response = await smetaAxios.get<{ Result: string; Sections: string; DocCfgID: string }>("GetDocInfo", {
    prefix: Prefixes.doccfg,
    params: { DocID: docId },
    loadMask: true,
  });
  if (response.Result == "1") return response;
  return false;
};

//функция обновления секций
//id: String
//если не указать id обновится текущая секция
export function updateSection(id: string | undefined = undefined, subID: string | undefined) {
  smetaStore.set(refreshSectionDataAtom, {
    refresh: true,
    refreshId: id,
    CommitFormOnSection: subID,
  });
}

//перевод входных данных(если оставить поле пустым("") оно не будет отображаться)
export function localization(): { [key: string]: string } {
  return {
    Country: "Страна", //0 = 0
    Region: "Регион", //1 = 1
    District: "Район", //2 = 2
    Settlement: "Сельское/городское поселение", //30 = 3
    City: "Город", //4 = 4
    CityPart: "Городской район", //19 = 5
    Community: "Населенный пункт", //3 = 6
    PlanStruct: "Элемент планировочной структуры", //22 = 7
    Street: "Улица", //5 = 8
    LandPlot: "Земельный участок", //23 = 9
    House: "Дом", //6 = 10
    BulkNo: "Корпус", //7 = 11
    BuildNo: "Строение", //25 = 12
    FlatNo: "Квартира", //8 = 13
    OfficeNo: "Помещение", //18 = 14
    Parking: "Машино-место", //29 = 15
    PostIndex: "Почтовый индекс", //10 = 16
    Phone: "Телефон", //12 = 17
    EMail: "Эл. Адрес", //13 = 18
    CodeNo: "Код НО", //11 = 19
    Classificator: "Классификатор", //9 = 20
    Identifier: "ФИАС (ГАР)", //21 = 21
    RegDate: "Дата регистрации", //17 = 22
    Options: "Адрес из ЕГРЮЛ", //20 = 23
    ShortName: "Сокращение",
    Code: "Код",
    IsShared: "", //15 = 23
    OKATD: "", //16 = 24
    BulkType: "", //14 = 25
    HouseType: "", //24 = 26
    BuildType: "", //26 = 27
    FlatType: "", //27 = 28
    RoomType: "", //28 = 29
  };
}

/**
 * Хук React, который сохраняет предыдущее значение переданного параметра.
 * @param value - Текущее значение, которое нужно отслеживать.
 * @returns Предыдущее значение `value`, или `undefined`, если это первое выполнение.
 * @example
 * const prevCount = usePrevious(count);
 * console.log(prevCount); // выводит предыдущее значение count
 */
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

//данные для сортировки(порядок записей: {входной индекс от сервера : необходимый индекс })
export function getSortAddressMap() {
  return {
    0: 0,
    1: 1,
    2: 2,
    3: 6,
    4: 4,
    5: 8,
    6: 10,
    7: 11,
    8: 13,
    9: 20,
    10: 16,
    11: 19,
    12: 17,
    13: 18,
    14: 26,
    15: 24,
    16: 25,
    17: 22,
    18: 14,
    19: 5,
    20: 23,
    21: 21,
    22: 7,
    23: 9,
    24: 27,
    25: 12,
    26: 28,
    27: 29,
    28: 30,
    29: 15,
    30: 3,
  };
}

//Сортировка записей по заданному порядку
export function sortAddresArray(array = [], sortedMap = getSortAddressMap()) {
  const result = new Array(30);
  const sortMap = sortedMap;
  for (let i = 0; i < array.length; i++) {
    result[sortMap[i]] = array[i];
  }
  return result;
}

//Создание объекта для Params
export function getParamsObject(items: any, selectedRecordID?: string, title?: any, parentModule?: string | Prefixes) {
  resultArray = [];
  const itemArray = sortAddresArray(items.Values, getSortAddressMap());
  const localize = localization();
  let ID = 0;
  let EditStyle, HouseType: boolean;
  itemArray.forEach((item, index) => {
    if (localize[item.FieldName] !== "") {
      switch (index) {
        case 10:
          HouseType = true;
          item.Conditions = "1";
          EditStyle = "81";
          break;
        case 11:
          HouseType = true;
          item.Conditions = "1";
          EditStyle = "81";
          break;
        case 12:
          HouseType = true;
          item.Conditions = "1";
          EditStyle = "81";
          break;
        case 13:
          HouseType = true;
          item.NoKldr = true;
          EditStyle = undefined;
          break;
        case 14:
          HouseType = true;
          item.NoKldr = true;
          EditStyle = undefined;
          break;
        case 16:
          EditStyle = "64";
          break;
        case 20:
          EditStyle = "64";
          break;
        case 21:
          EditStyle = "64";
          break;
        case 22:
          EditStyle = "2";
          break;
        case 23:
          EditStyle = "68";
          item.CheckState = item.Value;
          item.Value = undefined;
          break;
        default:
          if (item.DataType) {
            EditStyle = "80";
          } else {
            if (item.FieldName === "FlatNo" || item.FieldName === "OfficeNo") {
              item.Conditions = "1";
            }
            EditStyle = undefined;
            HouseType = false;
          }
      }
      resultArray.push({
        ID: ID,
        FieldName: item.FieldName,
        Name: item.Name ? item.Name : localize[item.FieldName],
        Value: item.Value,
        CheckState: item.CheckState,
        EditStyle: EditStyle,
        HouseType: HouseType,
        DataType: item.DataType ? item.DataType : "",
        ObjRef: item.ID,
        Conditions: item.Conditions,
        NoKldr: item.NoKldr,
        Level: item.FieldName === "CityPart" ? "1" : undefined,
        Current: items.ID,
        GroupID: selectedRecordID,
        Module: "books",
      });
      ID++;
      if (
        item.ShortName ||
        item.FieldName === "District" ||
        item.FieldName === "City" ||
        item.FieldName === "Community" ||
        item.FieldName === "Region" ||
        item.FieldName === "Settlement"
      ) {
        resultArray.push({
          ID: ID,
          FieldName: "ShortName",
          Name: localize["ShortName"],
          Value: item.ShortName,
          EditStyle: "64",
          Level: "1",
        });
        ID++;
      }
      if (item.Code || item.FieldName === "Region") {
        if (item.FieldName !== "Region") return;
        resultArray.push({
          ID: ID,
          FieldName: "Code",
          Name: localize["Code"],
          Value: item.Code,
          EditStyle: "64",
          Level: "1",
        });
        ID++;
      }
    }
  });
  return {
    ID: items.ID,
    address: title,
    Module: "address",
    parentModule: parentModule,
    Caption: items.Caption,
    Items: resultArray,
    Path: "Address",
    GroupID: selectedRecordID,
    NoHistory: true,
    division: items.dv ? items.dv : "0",
  };
}

export function AddressEditKladrObj(ID: string | number, DataType: string | number, Name: string) {
  const params = new Map();
  params
    .set("prefix", "address")
    .set("comand", "AddressEditKladrObj")
    .set("ID", ID)
    .set("Level", DataType ? DataType : "1")
    .set("Name", Name)
    .set("WSM", "1");

  const res = XMLrequest(params);
  return res;
}

/**
 * Функция создания всплывающего окна с подтверждением.
 * @param title Текст сообщения в окне подтверждения.
 * @param onConfirm Функция, которая выполнится после подтверждения действия.
 * @param setPrevVal Функция для сохранения предыдущего значения.
 * @param prevVal Предыдущее значение, передаваемое в setPrevVal.
 */
export function createConfirmation<T>(
  title: string,
  onConfirm: () => Promise<void> | void,
  setPrevVal?: (value: T) => void,
  prevVal?: T,
) {
  smetaModals.open(
    <>
      <div
        style={{
          height: "calc(100% - 40px)",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <span>{title}</span>
      </div>
      <div style={{ height: "40px", display: "flex", justifyContent: "center" }}>
        <Button
          onClick={() => {
            onConfirm();
            smetaModals.close();
          }}
          variant="outlined"
          style={{ marginRight: "30px", height: "34px" }}
          className="button_Modal_Select"
        >
          Да
        </Button>
        <Button
          onClick={() => {
            setPrevVal?.(prevVal!);
            smetaModals.close();
          }}
          variant="outlined"
          style={{ height: "34px" }}
          className="button_Modal_Close"
        >
          Нет
        </Button>
      </div>
    </>,
    {
      Title: "Подтверждение",
      style: { height: "150px", width: "380px" },
      hiddenButton: true,
      blockResize: true,
      blockMaximize: true,
    },
  );
}

export function AutoTextTranslate(str: string) {
  const search = [
    "й",
    "ц",
    "у",
    "к",
    "е",
    "н",
    "г",
    "ш",
    "щ",
    "з",
    "х",
    "ъ",
    "ф",
    "ы",
    "в",
    "а",
    "п",
    "р",
    "о",
    "л",
    "д",
    "ж",
    "э",
    "я",
    "ч",
    "с",
    "м",
    "и",
    "т",
    "ь",
  ];
  const replace = [
    "q",
    "w",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "\\[",
    "\\]",
    "a",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    ";",
    "'",
    "z",
    "x",
    "c",
    "v",
    "b",
    "n",
    "m",
  ];

  function checkCase(letter: string, i: number) {
    return letter === letter.toLowerCase() ? search[i] : search[i].toUpperCase();
  }

  for (let i = 0; i < replace.length; i++) {
    const reg = new RegExp(replace[i], "mig");
    str = str.replace(reg, (a) => checkCase(a, i));
  }
  return str;
}

export async function updateVisibleGrids(settings?: { last: boolean }) {
  if (CheckModalBackGrounds() === 0) {
    await updateInnerGrids(document);
    return;
  } else {
    const modals = document.querySelectorAll(".background_ModalDialog");
    if (modals.length === 0) return;

    if (settings?.last) {
      const lastModal = modals[modals.length - 1];
      await updateInnerGrids(lastModal);
      return;
    }

    for (const modal of Array.from(modals)) {
      await updateInnerGrids(modal);
    }
  }
}

const updateInnerGrids = async (panel: any) => {
  const gridpanels = panel.querySelectorAll("[rcsgrid_panel]");
  if (gridpanels.length) {
    for (let gridPanel of Array.from(gridpanels)) {
      if (gridPanel.checkVisibility()) {
        await gridPanel?.grid?.updateGridSize();
      }
    }
  }
};

//функция для обновления всех таблиц
//timer - количество миллисекунд по истечении которых произойдет обновление
export function updateGridData(timer: number = 0, settings?: { last: boolean }) {
  return new Promise((resolve) => {
    setTimeout(async () => {
      await updateVisibleGrids(settings);
      resolve(null);
      //здесь можно добавить id таблицы
    }, timer);
  });
}

export function throttle(callee: any, timeout: any) {
  // Таймер будет определять,
  // надо ли нам пропускать текущий вызов.
  let timer: any = null;

  // Как результат возвращаем другую функцию.
  // Это нужно, чтобы мы могли не менять другие части кода,
  // чуть позже мы увидим, как это помогает.
  return function perform(...args) {
    // Если таймер есть, то функция уже была вызвана,
    // и значит новый вызов следует пропустить.
    if (timer) return;

    // Если таймера нет, значит мы можем вызвать функцию:
    timer = setTimeout(async () => {
      // Аргументы передаём неизменными в функцию-аргумент:
      await callee(...args);

      // По окончании очищаем таймер:
      clearTimeout(timer);
      timer = null;
    }, timeout);
  };
}

interface ModalStyle {
  height?: string;
  width?: string;
  minHeight?: string;
  minWidth?: string;
  maxHeight?: string;
  maxWidth?: string;
}

export function getStyleWindow(CLSID: string | undefined = undefined) {
  const data: Record<string, ModalStyle> = {
    [ViewClass.TreeView]: {
      height: `${420}px`,
      width: `${(window.innerWidth / 100) * 35}px`,
    },
    [ViewClass.ClsBook]: {
      height: window.innerHeight * 0.6 + "px",
      width: window.innerWidth * 0.4 + "px",
    },
    [ViewClass.OrgBook]: {
      height: window.innerHeight * 0.7 + "px",
      width: window.innerWidth * 0.7 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    [ViewClass.UserReps]: {
      height: window.innerHeight * 0.75 + "px",
      width: window.innerWidth * 0.8 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    [ViewClass.PersonBook]: {
      height: window.innerHeight * 0.6 + "px",
      width: window.innerWidth * 0.65 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    [ViewClass.DocBook]: {
      width: window.innerWidth * 0.7 + "px",
      height: window.innerHeight * 0.75 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    [ViewClass.Address]: {
      height: `${420}px`,
      width: `${(window.innerWidth / 100) * 35}px`,
      minHeight: "300px",
      minWidth: "600px",
    },
    [ViewClass.TableRep]: {
      height: `${420}px`,
      width: `${(window.innerWidth / 100) * 35}px`,
    },
    [ViewClass.CalcRange]: {
      height: "300px",
      width: "310px",
      minHeight: "300px",
      minWidth: "310px",
      maxHeight: "300px",
      maxWidth: "310px",
    },
    [ViewClass.LongTime]: {
      minHeight: "230px",
      minWidth: "265px",
      maxHeight: "230px",
      maxWidth: "265px",
    },
    [ViewClass.MonthRange]: {
      height: "300px",
      width: "480px",
      minHeight: "300px",
      minWidth: "480px",
    },
    [ViewClass.DateRange]: {
      height: "500px",
      width: "410px",
      minHeight: "500px",
      minWidth: "410px",
      maxHeight: "500px",
      maxWidth: "410px",
    },
    [ViewClass.CreateObject]: {
      height: "180px",
      width: "480px",
      minHeight: "180px",
      minWidth: "480px",
    },
    [ViewClass.CreateObject + "Group"]: {
      height: `450px`,
      width: `${(window.innerWidth / 100) * 40}px`,
      minHeight: "420px",
      minWidth: "480px",
    },
    [ViewClass.AccCors]: {
      height: window.innerHeight * 0.6 + "px",
      width: window.innerWidth * 0.65 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    [ViewClass.StgBook]: {
      height: window.innerHeight * 0.7 + "px",
      width: window.innerWidth * 0.7 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    [ViewClass.Departs]: {
      height: window.innerHeight * 0.6 + "px",
      width: window.innerWidth * 0.65 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    [ViewClass.DocSite]: {
      width: window.innerWidth * 0.7 + "px",
      height: window.innerHeight * 0.75 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    [ViewClass.MultiTab]: {
      height: window.innerHeight * 0.8 + "px",
      width: window.innerWidth * 0.8 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    [ViewClass.CellObj]: {
      height: window.innerHeight * 0.7 + "px",
      width: window.innerWidth * 0.7 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    [ViewClass.PayTypeSet]: {
      height: window.innerHeight * 0.7 + "px",
      width: window.innerWidth * 0.7 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    complex: {
      height: window.innerHeight * 0.6 + "px",
      width: window.innerWidth * 0.65 + "px",
      minHeight: "500px",
      minWidth: "680px",
    },
    InputText: {
      height: "150px",
      width: "450px",
    },
    EnterText: { height: "400px", width: "570px" },
    groupingOrg: {
      minWidth: `${window.innerWidth * 0.4}px`,
      minHeight: `${window.innerHeight * 0.4}px`,
      height: `${window.innerHeight * 0.4}px`,
      width: `${window.innerWidth * 0.4}px`,
    },
    [ViewClass.Calendar]: {
      height: "470px",
      width: "470px",
      minHeight: "470px",
      minWidth: "470px",
    },
    [ViewClass.TimeCfg]: {
      height: `${800}px`,
      width: `${(window.innerWidth / 100) * 75}px`,
      minHeight: "800px",
      minWidth: `${(window.innerWidth / 100) * 60}px`,
    },
    Sample: {
      height: "150px",
      width: "350px",
      minHeight: "150px",
      minWidth: "350px",
      maxHeight: "150px",
    },
    ShowDataSet: {
      height: "500px",
      width: window.innerWidth * 0.55 + "px",
      minHeight: "500px",
    },
    params: {
      height: "500px",
      width: window.innerWidth * 0.55 + "px",
      minHeight: "500px",
    },
    sequence: {
      height: "550px",
      width: "526px",
      minHeight: "550px",
      minWidth: "526px",
      maxHeight: "550px",
      maxWidth: "526px",
    },
    DayTypes: {
      height: "310px",
      width: "420px",
      minHeight: "310px",
      minWidth: "420px",
      maxHeight: "310px",
      maxWidth: "420px",
    },
    MessageBox: {
      height: "max-content",
      width: "max-content",
      maxWidth: "min-content",
      minWidth: "450px",
      minHeight: "150px",
    },
    SelectFromList: {
      height: window.innerHeight * 0.3 + "px",
      width: window.innerWidth * 0.4 + "px",
      minHeight: "300px",
      minWidth: "360px",
    },
    default: {
      height: `${450}px`,
      width: `${(window.innerWidth / 100) * 40}px`,
      minHeight: "420px",
      minWidth: "480px",
    },
  };
  return CLSID && data[CLSID] ? data[CLSID] : data.default;
}

export function getModalSectionID() {
  return 100 - CheckModalBackGrounds();
}

interface MenuItem {
  Caption: string;
  value?: string;
  Image?: JSX.Element;
  Disabled?: boolean;
}

interface MenuGroup {
  Table?: MenuItem[];
  Header?: MenuItem[];
  Grouping?: MenuItem[];
  Field?: MenuItem[];
}
interface DataMenuItem {
  NoClearState?: boolean;
  NoSaveSample?: boolean;
}

export function getDefaultMenu(selector?: string, data: DataMenuItem = {}) {
  const defaultMenu: Record<string, MenuGroup> = {
    organizations: {
      Table: [
        {
          Caption: "Показать в группе",
          value: "ShowGroupID",
        },
        {
          Caption: "Отметить для перемещения",
          value: "SelectToMove",
          Image: <ContentCut fontSize="small" />,
          Disabled: true,
        },
        {
          Caption: "Перенести в группу",
          value: "InsertToGroup",
          Image: <ContentPaste fontSize="small" />,
          Disabled: true,
        },
        { Caption: "Divider" },
        {
          Caption: "Новая запись",
          value: "Insert",
          Image: <PostAddIcon fontSize="small" />,
        },
        {
          Caption: "Удалить запись",
          value: "Delete",
          Image: <DeleteIcon fontSize="small" />,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark" },
      ],
      Header: [
        { Caption: "Divider" },
        {
          Caption: "По возрастанию",
          Image: <SortIcon fontSize="small" />,
          value: "Sort",
        },
        {
          Caption: "По убыванию",
          Image: <SortIcon fontSize="small" style={{ transform: "scale(1,-1)" }} />,
          value: "Sort-",
        },
        {
          Caption: "Снять сортировку",
          value: "ClearSort",
        },
        { Caption: "Divider" },
        { Caption: "Область группировки", value: "GroupShow" },
        { Caption: "Поиск по столбцу", value: "ColumnFilter" },
      ],
      Grouping: [
        { Caption: "Область группировки", value: "GroupShow" },
        {
          Caption: "Расширенная группировка",
          value: "GroupShowExtended",
          Disabled: true,
        },
      ],
    },
    grades: {
      Table: [
        {
          Caption: "Конфигурационные данные",
          value: "ConfigData",
          Disabled: true,
        },
        {
          Caption: "Восстановить из конфигурации",
          value: "ConfigRestore",
        },
        {
          Caption: "Копировать запись",
          value: "Copy",
          Image: <ContentCopy fontSize="small" />,
          Disabled: true,
        },
        {
          Caption: "Вырезать запись",
          value: "Cut",
          Image: <ContentCut fontSize="small" />,
          Disabled: true,
        },
        {
          Caption: "Вставить запись",
          value: "Paste",
          Image: <ContentPaste fontSize="small" />,
          Disabled: true,
        },
        { Caption: "Divider" },
        {
          Caption: "Новая запись",
          value: "Insert",
          Image: <PostAddIcon fontSize="small" />,
        },
        {
          Caption: "Удалить запись",
          value: "Delete",
          Image: <DeleteIcon fontSize="small" />,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark", Disabled: true },
      ],
      Header: [{ Caption: "Поиск по столбцу", value: "ColumnFilter" }],
    },
    clsbook: {
      Table: [
        {
          Caption: "Добавить группу",
          value: "AddGroup",
          Image: <AddBoxOutlinedIcon />,
        },
        {
          Caption: "Добавить подгруппу",
          value: "AddGroupInner",
          Image: <AddToPhotosOutlinedIcon />,
        },
        {
          Caption: "Восстановить из конфигурации",
          value: "Restore",
          Disabled: true,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark", Disabled: true },
      ],
      Header: [
        { Caption: "Divider" },
        { Caption: "Область группировки", value: "GroupShow" },
        { Caption: "Поиск по столбцу", value: "ColumnFilter" },
      ],
      Grouping: [
        { Caption: "Область группировки", value: "GroupShow" },
        {
          Caption: "Расширенная группировка",
          value: "GroupShowExtended",
          Disabled: true,
        },
      ],
    },
    schedule: {
      Table: [
        {
          Caption: "Новая запись",
          value: "Insert",
          Image: <PostAddIcon fontSize="small" />,
        },
        {
          Caption: "Удалить запись",
          value: "Delete",
          Image: <DeleteIcon fontSize="small" />,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark", Disabled: true },
      ],
      Header: [
        { Caption: "Divider" },
        { Caption: "Область группировки", value: "GroupShow" },
        { Caption: "Поиск по столбцу", value: "ColumnFilter" },
      ],
      Grouping: [
        { Caption: "Область группировки", value: "GroupShow" },
        {
          Caption: "Расширенная группировка",
          value: "GroupShowExtended",
          Disabled: true,
        },
      ],
    },
    personsChildren: {
      Table: [
        {
          Caption: "Обратить выделение",
          value: "ReverseSelected",
          Disabled: true,
        },
        {
          Caption: "Калькулятор",
          value: "Calculator",
          Disabled: true,
        },
        {
          Caption: "Новая запись",
          value: "Insert",
          Image: <PostAddIcon fontSize="small" />,
        },
        {
          Caption: "Удалить запись",
          value: "Delete",
          Image: <DeleteIcon fontSize="small" />,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark", Disabled: true },
      ],
      Header: [
        { Caption: "Divider" },
        { Caption: "Область группировки", value: "GroupShow" },
        { Caption: "Поиск по столбцу", value: "ColumnFilter" },
      ],
      Grouping: [
        { Caption: "Область группировки", value: "GroupShow" },
        {
          Caption: "Расширенная группировка",
          value: "GroupShowExtended",
          Disabled: true,
        },
      ],
    },
    personsTable: {
      Table: [
        {
          Caption: "Показать в группе",
          value: "ShowGroupID",
        },
        {
          Caption: "Отметить для перемещения",
          Image: <ContentCut fontSize="small" />,
          value: "SelectToMove",
        },
        {
          Caption: "Перенести в группу",
          Image: <ContentPaste fontSize="small" />,
          value: "InsertToGroup",
        },
        {
          Caption: "Заблокировать ФИО",
          value: "BlockFIO",
        },
        {
          Caption: "Отправить в архив личных карточек",
          value: "ArchiveUser",
        },
        { Caption: "Divider" },
        {
          Caption: "Отметить выбранных",
          value: "PinSelected",
        },
        {
          Caption: "Снять отметку",
          value: "UnPinSelected",
        },
        { Caption: "Divider" },
        {
          Caption: "Новая запись",
          value: "Insert",
          Image: <PostAddIcon fontSize="small" />,
        },
        {
          Caption: "Удалить запись",
          value: "Delete",
          Image: <DeleteIcon fontSize="small" />,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark", Disabled: true },
      ],
      Header: [
        { Caption: "Divider" },
        { Caption: "Область группировки", value: "GroupShow" },
        { Caption: "Поиск по столбцу", value: "ColumnFilter" },
      ],
      Grouping: [
        { Caption: "Область группировки", value: "GroupShow" },
        {
          Caption: "Расширенная группировка",
          value: "GroupShowExtended",
          Disabled: true,
        },
      ],
    },

    NFA: {
      Table: [
        {
          Caption: "Показать в группе",
          value: "ShowGroupID",
        },
        {
          Caption: "Отметить для перемещения",
          Image: <ContentCut fontSize="small" />,
          value: "SelectToMove",
          Disabled: true,
        },
        {
          Caption: "Отметить для копирования",
          Image: <ContentCopy fontSize="small" />,
          value: "SelectToCopy",
          Disabled: true,
        },
        {
          Caption: "Перенести в группу",
          Image: <ContentPaste fontSize="small" />,
          value: "InsertToGroup",
          Disabled: true,
        },
        { Caption: "Divider" },
        {
          Caption: "Создать группу объектов...",
          value: "CreateGroup",
        },
        {
          Caption: "Добавить к объекту",
          value: "AddToObject",
          Disabled: true,
        },
        {
          Caption: "Все объекты группы",
          value: "AllObjects",
        },
        { Caption: "Divider" },
        {
          Caption: "Новая запись",
          value: "Insert",
          Image: <PostAddIcon fontSize="small" />,
        },
        {
          Caption: "Удалить запись",
          value: "Delete",
          Image: <DeleteIcon fontSize="small" />,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark" },
      ],
      Header: [
        { Caption: "Divider" },
        {
          Caption: "По возрастанию",
          Image: <SortIcon fontSize="small" />,
          value: "Sort",
        },
        {
          Caption: "По убыванию",
          Image: <SortIcon fontSize="small" style={{ transform: "scale(1,-1)" }} />,
          value: "Sort-",
        },
        {
          Caption: "Снять сортировку",
          value: "ClearSort",
        },
        { Caption: "Divider" },
        { Caption: "Область группировки", value: "GroupShow" },
        { Caption: "Поиск по столбцу", value: "ColumnFilter" },
      ],
      Grouping: [
        { Caption: "Область группировки", value: "GroupShow" },
        {
          Caption: "Расширенная группировка",
          value: "GroupShowExtended",
          Disabled: true,
        },
      ],
    },
    HandleAccounts: {
      Table: [
        {
          Caption: "Обратить выделение",
          value: "ReverseSelected",
        },
        {
          Caption: "Калькулятор",
          value: "Calc",
        },
        { Caption: "Divider" },
        {
          Caption: "Новая запись",
          value: "Insert",
          Image: <PostAddIcon fontSize="small" />,
        },
        {
          Caption: "Удалить запись",
          value: "Delete",
          Image: <DeleteIcon fontSize="small" />,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark" },
      ],
      Header: [
        { Caption: "Divider" },
        {
          Caption: "По возрастанию",
          Image: <SortIcon fontSize="small" />,
          value: "Sort",
        },
        {
          Caption: "По убыванию",
          Image: <SortIcon fontSize="small" style={{ transform: "scale(1,-1)" }} />,
          value: "Sort-",
        },
        {
          Caption: "Снять сортировку",
          value: "ClearSort",
        },
        { Caption: "Divider" },
        { Caption: "Область группировки", value: "GroupShow" },
        { Caption: "Поиск по столбцу", value: "ColumnFilter" },
      ],
      Grouping: [
        { Caption: "Область группировки", value: "GroupShow" },
        {
          Caption: "Расширенная группировка",
          value: "GroupShowExtended",
          Disabled: true,
        },
      ],
    },
    history: {
      Table: [
        {
          Caption: "Копировать запись",
          value: "CopyRecord",
        },
        {
          Caption: "Вырезать запись",
          value: "CutRecord",
        },
        {
          Caption: "Вставить из буфера",
          value: "Paste",
        },
        {
          Caption: "Новая запись",
          value: "Insert",
          Image: <PostAddIcon fontSize="small" />,
        },
        {
          Caption: "Удалить запись",
          value: "Delete",
          Image: <DeleteIcon fontSize="small" />,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark" },
      ],
      Header: [{ Caption: "Поиск по столбцу", value: "ColumnFilter" }],
    },
    paytypes: {
      Table: [
        {
          Caption: "Восстановить из конфигурации",
          value: "ConfigRestore",
        },
        {
          Caption: "Новая запись",
          value: "Insert",
          Image: <PostAddIcon fontSize="small" />,
        },
        {
          Caption: "Удалить запись",
          value: "Delete",
          Image: <DeleteIcon fontSize="small" />,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark", Disabled: true },
      ],
      Header: [
        { Caption: "Divider" },
        { Caption: "Область группировки", value: "GroupShow" },
        { Caption: "Поиск по столбцу", value: "ColumnFilter" },
      ],
      Grouping: [
        { Caption: "Область группировки", value: "GroupShow" },
        {
          Caption: "Расширенная группировка",
          value: "GroupShowExtended",
          Disabled: true,
        },
      ],
    },
    distractions: {
      Table: [
        {
          Caption: "Скрыть отвлечение",
          value: "HideDistraction",
        },
        {
          Caption: "Показывать только используемые",
          value: "ShowOnlyUse",
        },
        {
          Caption: "Новая запись",
          value: "Insert",
          Image: <PostAddIcon fontSize="small" />,
        },
        {
          Caption: "Удалить запись",
          value: "Delete",
          Image: <DeleteIcon fontSize="small" />,
        },
        { Caption: "Divider" },
        { Caption: "Режим просмотра", value: "OnlyViewMode" },
        { Caption: "Сохранять отметку", value: "SaveMark", Disabled: true },
      ],
      Header: [
        { Caption: "Divider" },
        { Caption: "Область группировки", value: "GroupShow" },
        { Caption: "Поиск по столбцу", value: "ColumnFilter" },
      ],
      Grouping: [
        { Caption: "Область группировки", value: "GroupShow" },
        {
          Caption: "Расширенная группировка",
          value: "GroupShowExtended",
          Disabled: true,
        },
      ],
    },
    HandleParams: {
      Field: [
        { Caption: "Развернуть групповые параметры", value: "ExpandGroupParams" },
        { Caption: "Свернуть групповые параметры", value: "CollapseGroupParams" },
        { Caption: "Divider" },
        {
          Caption: "Сохранить значения параметров",
          value: "SaveSample",
          Disabled: data?.NoSaveSample ? true : false,
        },
        {
          Caption: "Очистить значения",
          value: "ClearValues",
          Disabled: data?.NoClearState ? true : false,
        },
      ],
    },
    addressParams: {
      Field: [],
    },
    personsPhoto: {
      Field: [
        {
          Caption: "Добавить фото",
          value: "SetPhoto",
        },
        {
          Caption: "Удалить фото",
          value: "DeletePhoto",
        },
      ],
    },
    tree: {
      Field: [],
    },
    docParams: {
      Field: [
        { Caption: "Сохранить значения параметров", value: "SaveSample" },
        { Caption: "Очистить значения", value: "ClearValues" },
        { Caption: "Фильтр параметров", value: "FilterParams" },
        // { Caption: "Настроить перечень параметров", value: "ParamsSettings" },
      ],
    },
  };
  return (selector && defaultMenu[selector]) || undefined;
}

export function getRightsData(rights: string | number) {
  /*вставка = 1
   редактирование = 2
   удаление = 4
   доступ = 8
   */

  const res = {
    insert: false,
    modify: false,
    delete: false,
    accsess: false,
  };
  const rightsValue = Number(rights);
  if (rightsValue === -1) {
    return {
      insert: true,
      modify: true,
      delete: true,
      accsess: true,
    };
  }

  res.insert = Boolean(rightsValue & 1);
  res.modify = Boolean(rightsValue & 2);
  res.delete = Boolean(rightsValue & 4);
  res.accsess = Boolean(rightsValue & 8);

  return res;
}

export function ClearAllLoadMask() {
  const loadMasks = document.querySelectorAll("[loadmask]");

  if (loadMasks.length > 0) {
    for (const val of loadMasks) {
      val.parentElement.remove();
    }
  }
}

export function fontFlagsToCss(flags?: number | string): React.CSSProperties {
  const value = Number(flags);
  if (!Number.isFinite(value) || value === 0) return {};
  return {
    fontWeight: value & FontStyle.Bold ? "bold" : undefined,
    fontStyle: value & FontStyle.Italic ? "italic" : undefined,
    textDecoration:
      [value & FontStyle.Underline && "underline", value & FontStyle.StrikeOut && "line-through"]
        .filter(Boolean)
        .join(" ") || undefined,
  };
}

// функция для перекодирования целого числа в цвет
export function setColor(intColor?: string | number) {
  function toHex(i: number) {
    const res = 0xff & i;
    if (res) {
      return res.toString(16).padStart(2, "0");
    } else return "00";
  }

  if (intColor === 0 || intColor === "" || isNaN(Number(intColor))) return "";
  let result = "#" + toHex(Number(intColor));
  result += toHex(Number(intColor) >> 8);
  result += toHex(Number(intColor) >> 16);
  return result;
}

export function getKeyCodeOfInt(int: number) {
  const letter = int & 0xff;
  let controlButton = int >> 8;
  if (controlButton === 64) controlButton = 17;
  if (controlButton === 0) return [letter];
  else return [controlButton, letter];
}

export async function formEdit(ClickedButton: any, func: any, request: any, RequestId: any, from: any) {
  let data, json;
  if (ClickedButton === "1") {
    data = {
      Result: ClickedButton,
      [request.Name]: request.Value,
    };
    if (request.$SourList || request.$DestList) {
      data.$SourList = request.$SourList;
      data.$DestList = request.$DestList;
    }
    if (request.Name === "ObjRef") {
      data["DocID"] = request.Value;
    }
    if (request.Selection) {
      data.Selection = request.Selection;
    }
  } else {
    data = { Result: ClickedButton };
  }
  if (RequestId) {
    const params = new Map();
    params.set("prefix", "project");
    params.set("comand", "ResumeRequest");
    params.set("RequestID", RequestId);
    params.set("WSM", "1");
    json = await AxiosRequest(true, params, data);
  }
  json = json ? json : {};
  tokenProcessingTest(json, {
    func: func,
    propsId: RequestId,
    from: from,
    props: { Request: request, Button: ClickedButton },
  });
}

export function getDateOfInt(int: string | number) {
  const startDate = new Date("1899-12-30");
  const date = new Date(startDate.setDate(startDate.getDate() + Number(int)));

  return getStrDateOfDateObj(date);
}

export function getStrDateOfDateObj(date: Date | Dayjs) {
  return dayjs(date).format("DD.MM.YYYY");
}
export function getStrTimeOfDateObj(date: Date) {
  return dayjs(date).format("HH.mm.ss");
}

export function getIntOfStrDate(value: string | undefined) {
  const date = getDateForDateObj(value);
  if (!date) return -1;
  // вычисление id даты (количество дней с 30.12.1899)
  const oneDay = 1000 * 60 * 60 * 24;
  const startDate = new Date("1899-12-30");
  const currentDate = new Date(date);
  const id = Math.round((currentDate.getTime() - startDate.getTime()) / oneDay);

  if (!id) return -1;
  return id;
}

/**
 * Возвращает дату в правильном формате для объекта Date
 *
 * @param str строка с датой в формате DD.MM.YYYY
 * @returns Возвращает строку в формате для объекта Date - YYYY-MM-DD
 */
export function getDateForDateObj(str?: string) {
  if (!str) return;
  const date = dayjs(str, ["YYYY-MM-DD", "DD.MM.YYYY"], true);
  return date.isValid() ? date.format("YYYY-MM-DD") : undefined;
}

export function getDateRusFormatWithId(str: string): { label: string; id: number | string } {
  const date = getDateForDateObj(str);

  if (date) {
    // // вычисление id даты (количество дней с 30.12.1899)
    const oneDay = 1000 * 60 * 60 * 24;
    const startDate = new Date("1899-12-30");
    const currentDate = new Date(date);
    let id = Math.round((currentDate.getTime() - startDate.getTime()) / oneDay);

    if (!id) id = -1;
    return { label: str === ".." ? "" : str, id: `${id}` };
  } else return { label: "", id: "" };
}

/**
 * Возвращает количество дней в указанном месяце данного года
 *
 * @param id номер месяца от 1 до 12
 * @param year год для определения високосности
 *
 * @returns возвращает количество дней в месяце
 */
export function getMaxDay(id: string | number, year: string | number) {
  const yearMonths: { [key: string]: string } = {
    ["0"]: "0",
    ["1"]: "31",
    ["2"]: Number(year) % 4 === 0 ? "29" : "28",
    ["3"]: "31",
    ["4"]: "30",
    ["5"]: "31",
    ["6"]: "30",
    ["7"]: "31",
    ["8"]: "31",
    ["9"]: "30",
    ["10"]: "31",
    ["11"]: "30",
    ["12"]: "31",
  };
  return Number(yearMonths[`${id}`] || 0);
}

interface ListItem {
  text: string;
  id: string;
}
interface EditorListItem {
  label: string;
  id: string;
}

export function getEditorListFormat(
  items: Array<ListItem | string>,
  subData?: { checklist: boolean },
): Array<EditorListItem> {
  if (!items || items.length === 0) return [];
  return items.map((item, index) => {
    if (typeof item !== "object") {
      if (subData?.checklist) {
        return { label: item, id: `${Math.pow(2, index)}` };
      }
      return { label: item, id: `${index}`, objRef: "0" };
    }
    if (subData?.checklist) {
      return { label: item.text, id: `${Math.pow(2, index)}` };
    }
    return { label: item.text, id: item.id };
  });
}

interface MonthInfo {
  year: number;
  /** Месяц (1-12) */
  month: number;
  firstDay: dayjs.Dayjs;
  /** Дата в виде `01.01.2001` */
  firstDayStr: string;
  firstDayInt: number;
  lastDay: dayjs.Dayjs;
  /** Дата в виде `01.01.2001` */
  lastDayStr: string;
  lastDayInt: number;
}

export function getMonthInfo(
  year: number | string = dayjs().year(),
  month: number | string = dayjs().month() + 1,
): MonthInfo {
  const parsedYear = typeof year === "string" ? parseInt(year) : year;
  const parsedMonth = typeof month === "string" ? parseInt(month) : month;
  const firstDay = dayjs(`${parsedYear}-${parsedMonth}-01`);
  const lastDay = firstDay.endOf("month");
  return {
    year: parsedYear,
    month: parsedMonth,
    firstDay,
    firstDayStr: firstDay.format("DD.MM.YYYY"),
    firstDayInt: getIntOfStrDate(firstDay.format("DD.MM.YYYY")),
    lastDay,
    lastDayStr: lastDay.format("DD.MM.YYYY"),
    lastDayInt: getIntOfStrDate(lastDay.format("DD.MM.YYYY")),
  };
}

export function getLocalAuditParams() {
  return {
    Items: [
      {
        EditStyle: "2",
        Options: "",
        Level: "",
        ID: "0",
        DataType: "",
        FieldName: "StartDate",
        Name: "Начальная дата",
        Value: getStrDateOfDateObj(new Date()),
        EditVal: getStrDateOfDateObj(new Date()),
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "2",
        Options: "",
        Level: "",
        ID: "1",
        DataType: "",
        FieldName: "EndDate",
        Name: "Конечная дата",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "1",
        Options: "",
        Level: "",
        ID: "2",
        DataType: "",
        FieldName: "EventType",
        Name: "Событие",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "1",
        Options: "",
        Level: "",
        ID: "3",
        DataType: "",
        FieldName: "ConfigName",
        Name: "Конфигурация",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "1",
        Options: "",
        Level: "",
        ID: "4",
        DataType: "",
        FieldName: "OrgName",
        Name: "Организация",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "1",
        Options: "",
        Level: "",
        ID: "5",
        DataType: "",
        FieldName: "UserName",
        Name: "Пользователь",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "1",
        Options: "",
        Level: "",
        ID: "6",
        DataType: "",
        FieldName: "Address",
        Name: "IP-адрес",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "1",
        Options: "",
        Level: "",
        ID: "7",
        DataType: "",
        FieldName: "Computer",
        Name: "Компьютер",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "1",
        Options: "",
        Level: "",
        ID: "8",
        DataType: "",
        FieldName: "Server",
        Name: "Сервер",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "8",
        Options: "",
        Level: "",
        ID: "9",
        DataType: "",
        FieldName: "ObjectID",
        Name: "Значение Объекта",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "",
        Options: "",
        Level: "",
        ID: "10",
        DataType: "",
        FieldName: "EventInfo",
        Name: "Информация",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
      {
        EditStyle: "",
        Options: "",
        Level: "",
        ID: "11",
        DataType: "",
        FieldName: "Sender",
        Name: "Дополнительно",
        Value: "",
        EditVal: "",
        ObjRef: "",
        CheckState: "",
        TextStyle: "",
      },
    ],
  };
}

// Иконки состояний
export const LeftArrowBlue = (
  <img style={{ transform: "rotate(180deg)" }} checkicon={"true"} src={checkboxRightArrowBlueIcon} />
);

export const RightArrowRed = <img checkicon={"true"} src={checkboxRightArrowRedIcon} />;

// иконки в виде текста для вставки напрямую в разметку
const UncheckedString = "";
const CheckedString = `<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeMedium svg-icon css-kry165" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CheckIcon" tabindex="-1" title="Check"><path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></svg>`;
const BulletString = `<img
    checkicon="true"
    src="${checkboxBulletIcon}"
  />`;
const LeftArrowBlueString = `<img
    style="transform: rotate(180deg)"
    checkicon="true"
    src="${checkboxRightArrowBlueIcon}"
  />`;
const RightArrowRedString = `<img
      checkicon="true"
      src="${checkboxRightArrowRedIcon}"
    />`;

// Для секции виды начислений
export function getMulticheckIconForTree(checkstate: string | number) {
  const icons: Record<string, string> = {
    "1": UncheckedString,
    "2": CheckedString,
    "9": BulletString,
    "11": LeftArrowBlueString,
    "12": RightArrowRedString,
  };

  return icons[checkstate];
}

export function getCurrentUserRights(objType: number | string, isAsync?: false): string;
export function getCurrentUserRights(objType: number | string, isAsync?: true): Promise<string>;
export function getCurrentUserRights(objType: number | string, isAsync = false) {
  const userIsAdmin = smetaStore.get(isAdminAtom);
  if (userIsAdmin) return "-1";
  const userRights = smetaStore.get(userRightsAtom);
  if (userRights[objType] !== undefined) return userRights[objType];
  if (isAsync) {
    return new Promise<string>(async (resolve) => {
      const json = await smetaAxios.get<{ Result?: string }>("GetObjectRights", {
        prefix: Prefixes.usercfg,
        params: { ObjType: objType },
        loadMask: true,
      });
      const objTypeRights = json ? json.Result || "0" : "-1";
      userRights[objType] = objTypeRights;
      resolve(objTypeRights);
    });
  } else {
    const params = new Map();
    params.set("prefix", "usercfg").set("comand", "GetObjectRights").set("ObjType", objType);
    const json = XMLrequest(params) as { Result?: string };
    const objTypeRights = json ? json.Result || "0" : "-1";
    userRights[objType] = objTypeRights;
    return objTypeRights;
  }
}

export function checkRightsFlag(rights: string | number | PermissionFlags, flag: number) {
  const rightsData = typeof rights === "object" ? rights : getRightsData(rights);
  switch (flag) {
    case mfEdit:
      return rightsData.modify;
    case mfDelete:
      return rightsData.delete;
    case mfView:
      return rightsData.accsess;
    default:
      return rightsData.insert;
  }
}

export function checkCurrentUserRights(objType: number | string, flag: number, isAsync?: false): boolean;
export function checkCurrentUserRights(objType: number | string, flag: number, isAsync?: true): Promise<boolean>;
export function checkCurrentUserRights(objType: number | string, flag: number, isAsync = false) {
  if (isAsync) {
    return new Promise<boolean>(async (resolve) => {
      resolve(checkRightsFlag(await getCurrentUserRights(objType, isAsync), flag));
    });
  } else {
    return checkRightsFlag(getCurrentUserRights(objType), flag);
  }
}

export const getBaseUrl = () => {
  let path = window.location.pathname;
  if (!path.endsWith("/")) path = path.replace(/[^/]+$/, ""); // убрать последний сегмент
  return path;
};

export function getIntervalActualVersionWebsite() {
  const intervalDelay = smetaStore.get(appConfig).smeta.versionCheckInterval || 600000;
  const replaceVer = (str: string) => str.replace("/", ".").replace("hotfix", "");
  const needRefreshWebsite = (old: string, now: string) => {
    const olda = replaceVer(old).split("."),
      nowa = replaceVer(now).split(".");
    const last = Math.min(olda.length, nowa.length);
    for (let i = 0; i < last; i++) {
      if (parseInt(olda[i]) < parseInt(nowa[i])) {
        return true;
      }
    }
    return olda.length < nowa.length;
  };
  return setInterval(async () => {
    try {
      if (document.getElementById("UpdateVersionWebsite")) return;
      const currentVersionWebsite = smetaStore.get(appConfig).smeta.stimateVersion;
      const location = window.location;
      const baseUrl = getBaseUrl();
      const response = await axios.get(`${baseUrl}ver.json`);
      const responseVer = response.data;
      if (typeof responseVer !== "object" || isEmptyObject(responseVer)) return;
      const actualVersionWebsite = responseVer.version;
      if (!needRefreshWebsite(currentVersionWebsite, actualVersionWebsite)) return;
      renderMessageBox({
        dlgType: DlgType.Information,
        buttons: DlgButton.Yes + DlgButton.No,
        message: "Обнаружена новая версия сайта.\r\nОбновить страницу?",
        selectF: (ev: React.MouseEvent<HTMLButtonElement>) => {
          if ((ev.target as HTMLButtonElement).value === DlgRes.Yes.toString()) location.reload();
        },
        idModal: "UpdateVersionWebsite",
      });
    } catch (error) {
      console.warn(error.message);
    }
  }, intervalDelay);
}

export function getOS() {
  let detectOS = "Unknown OS";

  if (navigator.userAgent.indexOf("Win") != -1) detectOS = "windows";

  if (navigator.userAgent.indexOf("Mac") != -1) detectOS = "MacOS";

  if (navigator.userAgent.indexOf("Linux") != -1) detectOS = "linux";
  return detectOS;
}

export function getBrowserType() {
  const test = (regexp: RegExp) => {
    return regexp.test(navigator.userAgent);
  };

  if (test(/opr\//i)) {
    return "Opera";
  } else if (test(/edg/i)) {
    return "Microsoft Edge";
  } else if (test(/chrome|chromium|crios/i)) {
    return "Chromium";
  } else if (test(/firefox|fxios/i)) {
    return "Mozilla Firefox";
  } else if (test(/safari/i)) {
    return "Apple Safari";
  } else if (test(/trident/i)) {
    return "Microsoft Internet Explorer";
  } else if (test(/ucbrowser/i)) {
    return "UC Browser";
  } else if (test(/samsungbrowser/i)) {
    return "Samsung Browser";
  } else {
    return "Unknown browser";
  }
}
